/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import CallBack from "./pages/CallBack";
import AdminHeader from "./pages/header/AdminHeader";   
import Dashboard from "./pages/components/dashboard";
import Customer from "./pages/components/customer";
import Reports from "./pages/components/reports";
import Ecommerce from "./pages/components/Ecommercs";

export const origin = process.env.REACT_APP_BACKEND_URL;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/microsoft/callback" element={<CallBack />} />

          {/* Protected Layout */}
          <Route element={<AdminHeader />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customer"   element={<Customer />} />
            <Route path="/ecommerce"   element={<Ecommerce />} />
            <Route path="/reports"    element={<Reports />} />
          </Route>

          <Route path="*" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;














